import React, { VFC } from 'react';

import { NutritionDisclaimer } from '../nutrition-disclaimer';
import { INutritionDisclaimer } from '../types';

export const NutritionModalDisclaimer: VFC<INutritionDisclaimer> = ({ content }) => (
  <NutritionDisclaimer content={content} />
);
